import returnFromVendor from '@/api/stock/return-from-vendor'
import moment from 'moment'

import { baseState, baseMutations } from '@/store/mixins'

export const state = {
  ...baseState,
  branch_id: [],
  returnToVendor: [],
  dateRange: [moment().add(-7, 'days').format('DD-MM-YYYY'), moment().format('DD-MM-YYYY')]
}

export const getters = {}

export const mutations = {
  ...baseMutations,
    SET_DATE_RANGE(state, date){
        state.dateRange = date
    },
    SET_RETURN_TO_VENDOR_LIST(state, data){
        state.returnToVendor = data
    }
}

export const actions = {
  fetch(context, attrubutes = {}) {
    let params = Object.assign(
      {
        page: context.state.pagination.page,
        perPage: context.state.pagination.perPage,
        filter: {
          search: context.state.search,
          date_between: _.join(context.state.dateRange, ',')
        }
      },
      attrubutes
    )
    return returnFromVendor.get({ params }).then(response => {
      context.commit('RECEIVE_RESOURCES', response)
      return Promise.resolve(response)
    })
  },
  store(context, data) {
    return returnFromVendor.store(data)
  },
  getStockInByNumber(context, data) {
    return returnFromVendor.stockInByNumber(data)
  },
  update(context, { id, data }) {
    return returnFromVendor.update(id, data)
  },
  destroy(context, id){
    return returnFromVendor.destroy(id)
  },
  async find(context, id) {
    if (_.isEmpty(context.state.edit_data)) {
      let response = await returnFromVendor.find(id)
      context.commit('SET_EDIT_DATA', response.data)
    }
  },
  findReturnToVendor(context, returnToVendorId){
    return returnFromVendor.findReturnToVendorList(returnToVendorId)
  },
  async fetchResource(context){
    let var_vendor_list = await returnFromVendor.returnToVendorList()
      context.commit('SET_RETURN_TO_VENDOR_LIST', var_vendor_list.data)
  }
}
